import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanding } from "./LandingContext";

function countUp(el) {
  if (el._done) return;
  el._done = true;
  const end = parseFloat(el.dataset.cnt);
  const suf = el.dataset.suf || "";
  const div = parseFloat(el.dataset.div || 1);
  const t0 = performance.now();
  const step = (t) => {
    const p = Math.min(1, (t - t0) / 1400);
    const v = (end / div) * (1 - Math.pow(1 - p, 3));
    el.textContent = Math.round(v).toLocaleString() + suf;
    if (p < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}

export function useLandingScroll() {
  const location = useLocation();
  const { setNavSolid, setActive, menuOpen } = useLanding();

  useEffect(() => {
    let raf = 0;
    let lastActive = -1;
    let lastSolid = null;
    const tick = () => {
      const vh = window.innerHeight || 800;
      const root = document.getElementById("chz");
      if (!root) {
        raf = requestAnimationFrame(tick);
        return;
      }

      const catVideo = root.querySelector(".cat-box-video");
      if (catVideo && !catVideo._primed) {
        catVideo._primed = true;
        catVideo.muted = true;
        catVideo.loop = true;
        const pr = catVideo.play();
        if (pr && pr.catch) pr.catch(() => {});
      }

      root.querySelectorAll(".rv").forEach((el) => {
        const r = el.getBoundingClientRect();
        const vis = r.top < vh * 0.86 && r.bottom > vh * 0.06;
        if (vis && !el.classList.contains("in")) {
          el.classList.add("in");
          el.querySelectorAll("[data-cnt]").forEach((c) => countUp(c));
        } else if (!vis && el.classList.contains("in")) {
          el.classList.remove("in");
          el.querySelectorAll("[data-cnt]").forEach((c) => {
            c._done = false;
          });
        }
      });

      const isContact = location.pathname.includes("/contact");
      const isAbout = location.pathname.includes("/about");
      let solid = false;
      if (isContact) {
        solid = true;
      } else {
        const heroEl = document.getElementById(isAbout ? "about" : "hero");
        if (heroEl) solid = heroEl.getBoundingClientRect().bottom < 80;
      }
      if (solid !== lastSolid) {
        lastSolid = solid;
        setNavSolid(solid);
      }

      const scrub = root.querySelector(".svc-scrub");
      const track = root.querySelector(".svc-scrub-track");
      if (track && scrub && window.matchMedia("(min-width: 881px)").matches) {
        const rect = track.getBoundingClientRect();
        const travel = Math.max(1, track.offsetHeight - vh);
        const scrolled = Math.min(travel, Math.max(0, -rect.top));
        const progress = scrolled / travel;
        const stepsAttr = scrub.style.getPropertyValue("--svc-steps");
        const steps =
          Number(stepsAttr) ||
          Number(getComputedStyle(scrub).getPropertyValue("--svc-steps")) ||
          root.querySelectorAll(".svc-item").length ||
          10;
        const idx = Math.min(steps - 1, Math.floor(progress * steps + 1e-6));
        if (idx !== lastActive) {
          lastActive = idx;
          setActive(idx);
        }
      }

      const nav = root.querySelector(".nav-wrap");
      if (nav) document.documentElement.style.setProperty("--nav-h", `${nav.offsetHeight}px`);

      raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [location.pathname, setNavSolid, setActive]);

  useEffect(() => {
    document.body.classList.toggle("chz-menu-open", menuOpen);
    return () => document.body.classList.remove("chz-menu-open");
  }, [menuOpen]);
}
